import { useQuery } from "react-query";

import { useJsonApi } from "@/modules/api/hooks/useJsonApi";
import { queryKeys } from "@/modules/api/queryKeys";
import { useAuthContext } from "@/modules/auth/hooks/useAuthContext";
import {
  getHandbooksQuery,
  GetHandbooksResponse,
} from "@/modules/handbooks/api/queries/getHandbooksQuery";

const serializeHandbooks = (fetchedHandbooks: GetHandbooksResponse["data"]) => {
  return fetchedHandbooks?.map((handbook) => ({
    id: handbook.id,
    name: handbook.attributes.name,
    usedInTutorialCount: handbook.meta.usedInTutorialCount,
  }));
};

export function useGetHandbooksQuery(keywordValue: string) {
  const jsonApi = useJsonApi();
  const { userCompanyId } = useAuthContext();

  return useQuery(
    userCompanyId
      ? {
          queryKey: [
            queryKeys.handbooks.getHandbooksList,
            keywordValue,
            userCompanyId,
          ],
          queryFn: () =>
            getHandbooksQuery(jsonApi, {
              companyId: userCompanyId,
              keywordValue: keywordValue,
            }),
          select: (response) => {
            if (response) {
              return serializeHandbooks(response.data);
            }
          },
          retry: false,
          refetchOnWindowFocus: false,
        }
      : { enabled: false }
  );
}
